import { combineI18nMessages, defaultMessagesBG } from "@duosoftbg/nacid-components";

const messagesBg = combineI18nMessages(defaultMessagesBG, {
  translation: {
    "t.page.registers": "Регистри и бази данни",
    "t.eRegisters": "Регистри и бази данни",
    "t.ePortal": "Електронен портал",
    "t.page.professionalQualifications": "Професионални квалификации",
    "t.page.academicRecognition": "Академично признаване",
    "t.academicRecognition.nacid": "Академично признаване от НАЦИД",
    "t.academicRecognition.universities": "Академично признаване с решения на висши училища",
    "t.detail.academicRecognition": "Преглед на академично признаване",
    "t.detail.academicRecognition.nacid": "Регистър за академично признаване от НАЦИД - заявление",
    "t.detail.academicRecognition.universities": "Преглед на академично признаване с решения на висши училища",
    "t.detail.professional.qualification": "Преглед на професионална квалификация",
    "t.modal.searchFilters.instruction": "Моля изберете подходящи критерии за търсене",
    "t.modal.searchFilters.searchCriteria": "Критерии за търсене",
    "t.acArUniEntryRequest":
      "Администриране на подадена информация към регистър Академично признаване с решения на висши училища",
    "t.acArUniEntryRequest.view": "Преглед",
    "t.arUniEntryRequest": "Подаване на информация към регистър Академично признаване с решения на висши училища",
    "t.arUniEntryRequest.new.short": "Ново",
    "t.arUniEntryRequest.edit.short": "Редакция",
    "t.arUniEntryRequest.view.short": "Преглед",
    "t.arUniEntryRequest.list.short": "Списък",
    "t.arUniEntryRequest.new":
      "Ново подаване на информация към регистър Академично признаване с решения на висши училища",
    "t.arUniEntryRequest.edit":
      "Редакция на запис за подаване на информация към регистър Академично признаване с решения на висши училища",
    "t.arUniEntryRequest.view":
      "Преглед на запис за подаване на информация към регистър Академично признаване с решения на висши училища",
    "t.arUniEntryRequest.list":
      "Списък със записи за подаване на информация към регистър Академично признаване с решения на висши училища",
    "t.arUniEntryRequest.applicant.details": "Притежател на дипломата",
    "t.arUniEntryRequest.notes": "Бележки",
    "t.arUniEntryRequest.recognized.details": "Признати данни",
    "t.arUniEntryRequest.diplomaUni.details": "Чуждестранно ВУ и данни от дипломата",
    "t.arUniEntryRequest.common.details": "Обща информация",
    "t.arUniEntryRequest.confirm.dialog": "Моля потвърдете",
    "t.arUniEntryRequest.relatedRecognition.details": "Предходно вписване",
    "t.seRecognition.checkup": "Преглед по код на документ",
    "t.seRecognition.checkup.short": "Преглед по код на документ",
    "t.seRecognition.qr.view": "Преглед по QR код",
    "t.seRecognition.qr.view.short": "Преглед по QR код",

    "l.searchFilter.nameExactMatch": "Наименование",
    "l.searchFilter.exactMatch": "Точно съвпадение",
    "l.searchFilter.applicationDate": "Дата",
    "l.searchFilter.applicant": "Заявител",
    "l.searchFilter.status": "Статус",
    "l.searchFilter.country": "Държава",
    "l.searchFilter.acquiredSpeciality": "Придобита специалност",
    "l.searchFilter.protocolNumber": "Протокол от заседание на Академичен съвет",
    "l.searchFilter.eduLevel": "Призната ОКС",
    "l.searchFilter.university": "Висше училище",
    "l.searchFilter.foreignUniversity": "Чуждестранно висше училище",
    "l.searchFilter.recognizedSpeciality": "Призната специалност",
    "l.searchFilter.recordNumber": "Делов. №",
    "l.searchFilter.decisionNumber": "№ на удост./решение",
    "l.searchFilter.recognizedProfessionName": "Удостоверена професионална квалификация",
    "l.searchFilter.applicationCountryName": "Кандидатства за държава",
    "l.table.head.recognizedProfessionName": "Удостоверена професионална квалификация",
    "l.table.head.applicationCountryName": "Кандидатства за държава",
    "l.table.head.recordNumber": "Делов. №",
    "l.table.head.date": "Дата",
    "l.table.head.applicant": "Заявител",
    "l.table.head.university": "Висше училище",
    "l.table.head.foreignUniversity": "Чуждестранно висше училище",
    "l.table.head.country": "Държава",
    "l.table.head.recognizedSpeciality": "Призната специалност",
    "l.table.head.acquiredSpeciality": "Придобита специалност",
    "l.table.head.recognizedEduLevel": "Призната ОКС",
    "l.table.head.acquiredEduLevel": "Придобита ОКС",
    "l.table.head.certificateNumber": "№ на удост./решение",
    "l.table.head.decisionNumber": "№ на удост./решение",
    "l.table.head.academicCouncilDecision": "Решение на Академичен съвет",
    "l.table.head.academicCouncilProtocol": "Протокол от заседание на Академичен съвет",
    "l.detail.applicationNumber": "Входящ номер",
    "l.detail.applicationDate": "Дата на заявяване",
    "l.detail.applicantName": "Заявител",
    "l.detail.university": "Висше училище",
    "l.detail.foreignUniversity": "Чуждестранно висше училище",
    "l.detail.universityCountry": "Държава",
    "l.detail.originalSpeciality": "Специалност",
    "l.detail.originalEduLevel": "ОКС",
    "l.recognizedSpeciality": "Призната специалност",
    "l.detail.recognizedEduLevel": "Призната ОКС",
    "l.detail.applicationStatus": "Статус",
    "l.detail.certificateNumber": "№ на удостоверение",
    "l.detail.refusalLegalReason": "Правна причина за отказ",
    "l.detail.invalidatedCertificateNumbers": "Невалидни удостоверения",
    "l.detail.citizenship": "Гражданство",
    "l.detail.educationLevel": "Придобита ОКС",
    "l.acquiredSpeciality": "Придобита специалност",
    "l.detail.diplomaNumber": "№ на диплома",
    "l.detail.diplomaDate": "Дата на издаване на диплома",
    "l.detail.protocolNumber": "Протокол от заседание на Академичен съвет",
    "l.recognizedUniversity": "ВУ, признало дипломата",
    "l.detail.inputNumber": "Входящ номер",
    "l.detail.outputNumber": "Изходящ номер",
    "l.detail.createdDate": "Дата на създаване",
    "l.detail.decisionNumber": "№ на удост./решение",
    "l.detail.notes": "Бележки",
    "l.detail.recognitionStatus": "Статус",
    "l.detail.relatedRecognition": "Входящ номер на свързано признаване",
    "l.detail.applicationCountryName": "Кандидатства за държава",
    "l.detail.recognizedProfessionName": "Удостоверена професионална квалификация",
    "l.btn.newEntryRequest": "Подаване на нова информация към регистъра",
    "l.btn.myEntryRequests": "Моята подадена информация към регистъра",
    "l.arUniEntryRequest.applicant": "Имена на притежателя на дипломата",
    "l.arUniEntryRequest.applicantEan": "ЕАН",
    "l.arUniEntryRequest.citizenship": "Гражданство на притежателя на дипломата",
    "l.arUniEntryRequest.notes": "Бележки и допълнителна информация",
    "l.arUniEntryRequest.recognizingUniversity": "Български университет, признал дипломата",
    "l.arUniEntryRequest.protocolNumber": "Номер на заповед за признаване/отказ",
    "l.arUniEntryRequest.protocolDate": "Дата на заповед за признаване/отказ",
    "l.arUniEntryRequest.recognitionStatus": "Вид решение",
    "l.arUniEntryRequest.recognizedSpeciality": "Призната специалност",
    "l.arUniEntryRequest.recognizedEducationLevelId": "Призната ОКС/ОНС",
    "l.arUniEntryRequest.university": "Наименование на чуждестранното висше училище, издало дипломата",
    "l.arUniEntryRequest.universityCountry": "Държава по седалище на ЧВУ, издало дипломата",
    "l.arUniEntryRequest.diplomaNumber": "Диплома номер",
    "l.arUniEntryRequest.diplomaDate": "Диплома, дата на издаване",
    "l.arUniEntryRequest.diplomaSpeciality": "Придобита специалност",
    "l.arUniEntryRequest.educationLevel": "Придобита ОКС/ОНС",
    "l.arUniEntryRequest.createdDate": "Дата на създаване",
    "l.arUniEntryRequest.submittedDate": "Дата на подаване",
    "l.arUniEntryRequest.createdUser": "Потребител, създал записа",
    "l.arUniEntryRequest.requestStatus": "Статус на записа",
    "l.btn.arUniEntryRequest.saveData": "Запис на чернова",
    "l.btn.arUniEntryRequest.saveAndPublishData": "Публикуване в регистъра",
    "l.table.head.options": "Опции",
    "l.button.accept.arUniEntryRequest": "Прехвърли в регистър Академично признаване с решения на висши училища",
    "l.arUniEntryRequest.filter.createdUser": "Потребител, създал записа",
    "l.button.deny.arUniEntryRequest": "Откажи прехвърляне в регистъра",
    "l.arUniEntryRequest.relatedRecognitionId": "Предходно вписване",
    "l.arUniEntryRequest.acadrecUniId": "Съответстващ запис в регистъра",
    "l.arUniEntryRequest.recognizedProfGroup": "Признато професионално направление",
    "l.click.here": "Кликнете за да последвате линка",

    "l.arUniEntryRequest.filter.applicant": "Притежател на дипломата",
    "l.arUniEntryRequest.filter.university": "Чуждестранно ВУ",
    "l.arUniEntryRequest.filter.recognitionStatusId": "Вид решение",
    "l.arUniEntryRequest.filter.requestStatusId": "Статус",
    "l.arUniEntryRequest.filter.recognizingUniversity": "Български университет, признал дипломата",

    "l.arUniEntryRequest.table.head.applicant": "Притежател на дипломата",
    "l.arUniEntryRequest.table.head.recognizedEducationLevel": "Призната ОКС/ОНС",
    "l.arUniEntryRequest.table.head.acquiredEduLevel": "Придобита ОКС/ОНС",
    "l.arUniEntryRequest.table.head.protocolNumber": "Заповед за признаване/отказ",

    "m.academicRecognition.desc":
      "Обединеният регистър за академично признаване предоставя информация за всички издадени, отказани или обезсилени удостоверения за признаване на дипломи за висше образование, образователна и научна степен „доктор“ и научна степен „доктор на науките“. Регистърът е организиран в два под-раздела - раздел за признаване от НАЦИД с цел улесняване на достъпа до пазара на труда, до докторантура в научна организация и за други цели, когато заявителят има правен интерес и раздел за признаване от самите висши училища с цел достъп до по-нататъшно обучение, до обучение за повишаване на квалификацията и до докторантура, с възможност за обединено търсене в двата под-раздела по различни критерии и подробен преглед на данните за едно удостоверение в пълния им обем съгласно нормативната уредба.",
    "m.academicRecognition.desc.2": "Регистърът съдържа данни както следва:",
    "m.academicRecognition.desc.3": "- за ОКС бакалавър и магистър - от месец април 2009 г.",
    "m.academicRecognition.desc.4": "- за ОНС доктор и НС доктор на науките - от месец април 2019 г.",
    "m.professionalQualifications.desc":
      "Обединеният регистър на професионалните квалификации предоставя информация за всички издадени, отказани или обезсилени удостоверения за придобита професионална квалификация на територията на Република България, необходими за достъп или за упражняване на регулирана професия на територията на друга държава членка. Процедурата за издаване на удостоверения за квалификации по професии, които не са регулирани на територията на Република България се организира от НАЦИД. За професиите, които са регулирани на територията на Република България, удостоверенията се издават от съответните компетентни органи. Регистърът позволява търсене по различни критерии и подробен преглед на данните за едно удостоверение в пълния им обем съгласно нормативната уредба.",
    "m.professionalQualifications.desc.2": "Регистърът съдържа данни от месец април 2011 г.",
    "m.hideSearchCriteria": "Скрий критериите за търсене",
    "m.showSearchCriteria": "Покажи критериите за търсене",
    "m.resetFilters.success": "Изчистването приключи успешно!",
    "m.submitFilters.success": "Търсенето приключи успешно!",
    "m.alert.pleaseEnterValidSearchCriteria": "Моля въведете валидни критерии за търсене",
    "m.arUniEntryRequest.save.data.success": "Успешно запазихте вашата чернова",
    "m.arUniEntryRequest.saveAndPublish.data.success": "Успешно въведохте данните в регистъра",
    "m.arUniEntryRequest.reject.request.warn": "Сигурни ли сте, че желаете да отхвърлите този запис?",
    "m.arUniEntryRequest.accept.request.warn": "Сигурни ли сте, че желаете да прехвърлите този запис в регистъра?",
    "m.arUniEntryRequest.saveAndPublish.request.warn":
      "С това действие ще запазите направените промени и ще ги публикувате в регистъра. След публикуване на данните в регистъра не е желателно да правите промени по тях. Сигурни ли сте, че желаете да продължите?",
    "m.arUniEntryRequest.reject.request.success": "Успешно отказване на записа",
    "m.arUniEntryRequest.accept.request.success": "Успешно прехвърляне на записа в регистъра",
    "m.arUniEntryRequest.relatedRecognition.info":
      "При промяна или преразглеждане на вече взето решение, моля посочете тук предходното решение (номер на заповед и имена на лицето).",
    "m.warning.edit.accepted.register.record":
      "Този запис вече е въведен в регистъра. Моля, не публикувайте промени по него, освен ако не е абсолютно наложително. НАЦИД ще получи уведомление за публикуваните промени по регистъра. Не злоупотребявайте.",
    "m.seRecognitionSearchTitle": "Средно образование",
    "m.seRecognitionSearchDescription":
      "<strong>Имате възможност за проверка на издадени:</strong><br><br><ul style='padding-left: 20px; margin: 0;'><li style='margin-bottom: 5px;'><strong>удостоверения</strong> за признаване на средно образование, придобито в училище на чужда държава;</li><li style='margin-bottom: 5px;'><strong>уверения</strong> за признаване на средно образование, придобито в училище на чужда държава;</li><li style='margin-bottom: 5px;'><strong>служебни бележки</strong> за приравняване на оценки по изучавани учебни предмети, които не са включени в документа за завършено средно образование;</li><li style='margin-bottom: 5px;'><strong>дубликати</strong> на горепосочените документи;</li><li style='margin-bottom: 5px;'><strong>решения</strong> за отказ за признаване на средно образование, придобито в училище на чужда държава.</li></ul><br><div>За целта въведете кода за достъп, посочен в документа, и натиснете бутона <strong>„Търси\"</strong>. Ще се визуализират данните от документа, а за преглед на изображението му, натиснете на предоставения линк.</div><br><div>Базата данни съдържа информация за документи, <strong>издадени от НАЦИД след 01.10.2025 г</strong>.</div>",
    "m.seRecognitionSearchInfoText": "Помощна информация",
    "m.seRecognitionAccessCodeNotFound": "Не са намерени резултати по посочените критерии",
    "l.accessCode": "Код на документ",

    "l.diplomaOwner": "Притежател на диплома",
    "l.acquiredEduLevel": "Придобита ОКС/ОНС",
    "l.recognizedEduLevel": "Призната ОКС/ОНС",
    "l.recognizeRejectOrder": "Заповед за признаване/отказ",
    "l.decisionType": "Вид решение",
    "l.application": "Заявление",
    "l.legalReason": "Правно основание",
    "l.denialDecision": "Решение за отказ",
    "l.certificate": "Удостоверение",
    "l.certificateAndWeakenedOrder": "Удостоверение/Заповед за обезсилване",

    "l.qualificationFromDiploma": "Професионална квалификация",
    "l.recognizedQualification": "Призната професионална квалификация",
    "l.trainingInstitution": "Висше училище, провело обучението",
    "l.decisionProtocol": "Протокол с решение",
    "l.recognized": "Признато",
    "l.diplomaData": "Данни по диплома",
    "l.applicationData": "Заявление",
    "l.numberAndDate": "Номер и дата",
    "l.relatedEntries": "Свързани вписвания",
    "l.previousRecognition": "Предходни вписвания",
    "l.nextRecognition": "Последващи вписвания",
    "l.detail.accessCode": "Код на документ",
    "l.detail.bgProfession": "Професия",
    "l.detail.schoolName": "Наименование на училище",
    "l.detail.schoolSettlement": "Населено място",
    "l.detail.schoolCountry": "Държава",
    "l.download.decision": "Свали решение",
    "l.decisions": "Решения",
    "m.document.notFound": "Документът не е намерен!",

    "m.info.ar.nacid":
      "НАЦИД извършва признаване с цел <strong>улесняване на достъпа до пазара на труда</strong>, до <strong>докторантура в научна организация и за други цели, когато заявителят има правен интерес</strong>. Издаваното удостоверение е <strong>валидно на територията на Р България</strong>.",
    "m.info.ar.uni":
      "Висшите училища извършват признаване с цел <strong>достъп до по-нататъшно обучение, до обучение за повишаване на квалификацията</strong> и <strong>до докторантура</strong>. Взетото решение е <strong>валидно само във висшето училище за нуждите на приема там</strong>.",
  },
});

export default messagesBg;
